import { useUser } from "~/contexts/UserContext"
import { useTranslation } from "~/translations"

export default function useGreeting() {
	const user = useUser().user
	const t = useTranslation()

	if (user === null || user.firstName.trim().length === 0) return null

	const hours = new Date().getHours()

	if (hours > 3) {
		if (hours < 12) return t("dashboard.greeting.morning", { name: user.firstName })
		if (hours < 17) return t("dashboard.greeting.afternoon", { name: user.firstName })
		if (hours < 21) return t("dashboard.greeting.evening", { name: user.firstName })
	}
	return t("dashboard.greeting.night", { name: user.firstName })
}
